const types = {
  GET_ADVERTISER: 'advertisers/GET_ADVERTISER',
};

export default types;
